import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import MuiButton from '@mui/material/Button';
import { units } from '../theme/units';
const useStyles = makeStyles()(() => ({
    'iconSize-inherit': {
        '& > *:first-of-type': {
            fontSize: 'inherit',
        },
    },
    'iconSize-small': {
        '& > *:first-of-type': {
            fontSize: units.rem(0.5),
        },
    },
    'iconSize-medium': {
        '& > *:first-of-type': {
            fontSize: units.rem(1.25),
        },
    },
    'iconSize-large': {
        '& > *:first-of-type': {
            fontSize: units.rem(1.875),
        },
    },
}));
const Button = React.forwardRef(({ iconSize, classes, ...rest }, ref) => {
    const { classes: customClasses, cx } = useStyles();
    const newClasses = {
        ...classes,
        startIcon: cx(classes && classes.startIcon, customClasses[`iconSize-${iconSize}`]),
        endIcon: cx(classes && classes.endIcon, customClasses[`iconSize-${iconSize}`]),
    };
    return _jsx(MuiButton, { ...rest, ref: ref, classes: newClasses });
});
export { Button };
